import type * as React from 'react';
const SvgIcoLost = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
    <path d="M18.364 5.636 5.636 18.364zM12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9" stroke="currentColor" />
  </svg>
);
export default SvgIcoLost;
